import axios from 'axios'
const state = {
  suppliers: [],
}
const mutations = {
  setSuppliers (state, data) {
    state.suppliers = data
  },
}
const actions = {
  getAllSuppliers ({ commit }) {
    return axios
      .get(`${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/suppliers/`)
      .then(({ data }) => {
        commit('setSuppliers', data)
      })
      .catch(e => console.log(e))
  },
  searchSuppliers ({ commit }, credentials) {
    return axios
      .get(
        `${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/suppliers/${credentials}`,
      )
      .then(({ data }) => {
        commit('setSuppliers', data)
      })
      .catch(e => console.log(e))
  },
  addSupplier ({ dispatch }, credentials) {
    return axios
      .post(
        `${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/suppliers/`,
        credentials,
      )
      .then(() => {
        dispatch('getAllSuppliers')
      })
      .catch(e => {
        console.log(e)
      })
  },
  updateSupplier ({ dispatch }, credentials) {
    return axios
      .put(
        `${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/suppliers/${credentials.id}/`,
        credentials,
      )
      .then(() => {
        dispatch('getAllSuppliers')
      })
      .catch(e => {
        console.log(e)
      })
  },
  deleteSupplier ({ dispatch }, credentials) {
    return axios
      .delete(
        `${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/suppliers/${credentials}/`,
        credentials,
      )
      .then(() => {
        dispatch('getAllSuppliers')
      })
      .catch(e => {
        console.log(e)
      })
  },
}

export default {
  state,
  mutations,
  actions,
}
